import { render, staticRenderFns } from "./CCReadOnlyTable.vue?vue&type=template&id=2e3eff08&scoped=true"
import script from "./CCReadOnlyTable.vue?vue&type=script&lang=js"
export * from "./CCReadOnlyTable.vue?vue&type=script&lang=js"
import style0 from "./CCReadOnlyTable.vue?vue&type=style&index=0&id=2e3eff08&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3eff08",
  null
  
)

export default component.exports